import React from 'react';

const NoMatch = () => <h2>NoMatch</h2>;

export default NoMatch;
